import { toStartCaseString } from "@validereinc/utilities";

/** Tool/API names only — must include at least one underscore (e.g. call_read_api). */
const SNAKE_CASE_IDENTIFIER_PATTERN = /^[a-z][a-z0-9]*(_[a-z0-9]+)+$/;

const RUNNING_TOOL_DETAIL_PATTERN = /^(.+):\s*([a-z][a-z0-9]*(_[a-z0-9]+)+)$/;

/**
 * Labels for investigation progress phase/detail (e.g. model → Model).
 * Pure snake_case tool names are shown as emitted; prefixed agent copy is start-cased.
 */
export const formatInvestigationProgressDisplayText = (
  text: string
): string => {
  if (!text) {
    return text;
  }

  if (SNAKE_CASE_IDENTIFIER_PATTERN.test(text)) {
    return text;
  }

  const runningToolMatch = RUNNING_TOOL_DETAIL_PATTERN.exec(text);
  if (runningToolMatch) {
    const [, prefix, toolName] = runningToolMatch;
    return `${toStartCaseString(prefix.trim())}: ${toolName}`;
  }

  return toStartCaseString(text);
};
